<div class="container" *transloco="let t; prefix: 'profile'">
  <div class="panel">
    <div class="edit-header">
      <div class="header-title-section">
        <h1 class="header-title">{{ t('header') }}</h1>
        <p class="header-subtitle">{{ t('subtitle') }}</p>
      </div>
      <htx-button
        variant="tertiary"
        icon="save"
        (click)="save()"
        [disabled]="form.invalid || isSaving() || isOrganizationPending()"
      >
        {{ 'button.save' | transloco }}
      </htx-button>
    </div>

    @if (loadError()) {
      <htx-alert type="error">{{ t('loadError') }}</htx-alert>
    }

    @if (!isLoading()) {
      <div class="form-sections">
        <htx-form-section
          [title]="t('sections.personalInfo')"
          [icon]="'person'"
          [formGroup]="form"
          [showErrorSummary]="false"
        >
          <htx-dropdown-field
            [ctrl]="form.controls.title"
            [label]="t('controls.title.label')"
            [options]="salutationOptions()"
          >
          </htx-dropdown-field>
          <htx-text-field
            [ctrl]="form.controls.firstName"
            [label]="t('controls.firstName.label')"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.lastName"
            [label]="t('controls.lastName.label')"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.email"
            [label]="t('controls.email.label')"
            type="email"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.position"
            [label]="t('controls.position.label')"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.phoneNumber"
            [label]="t('controls.phoneNumber.label')"
          >
          </htx-text-field>
        </htx-form-section>
      </div>
    }
  </div>
</div>
